import { render } from "./PatientPrintModal.vue?vue&type=template&id=c932d01c"
import script from "./PatientPrintModal.vue?vue&type=script&lang=js"
export * from "./PatientPrintModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__